import styled from 'styled-components';

export const StyledDropzoneTemplate = styled.div`
  padding: 20px;
  border-radius: 6px;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }

  .body {
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
`;
